import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('Aplikacja działa z service workerem.')
    },
    registered() {
      console.log('Service worker został zarejestrowany.')
    },
    cached() {
      console.log('Zasoby zostały zapisane do cache.')
    },
    updatefound() {
      console.log('Pobierana jest nowa wersja aplikacji.')
    },
    updated() {
      console.log('Dostępna jest nowa wersja aplikacji. Odśwież stronę.')
    },
    offline() {
      console.log('Brak internetu. Aplikacja działa w trybie offline.')
    },
    error(error) {
      console.error('Błąd rejestracji service workera:', error)
    }
  })
}